import { render } from "./MontagesCreate.vue?vue&type=template&id=08326322&scoped=true"
import script from "./MontagesCreate.vue?vue&type=script&lang=js"
export * from "./MontagesCreate.vue?vue&type=script&lang=js"

import "./MontagesCreate.vue?vue&type=style&index=0&id=08326322&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08326322"]])

export default __exports__